<template>
    <sa-page-layout :btnNewVisible="false" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovo">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <sa-filter-component @submit="onSubmitFarmacie" @reset="resetfiltroDiagnosi">
                <b-form style="width: 100%">
                    <b-row class="sa-form-btn-filter">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Categoria</label>
                            <b-form-select class="sa-page-search-component-input" v-model="filtroDiagnosi.codiceCategoria" :options="categorieOptions" value-field="categoria" text-field="descrizione"></b-form-select>
                            <!-- <input class="sa-page-search-component-input" v-model="filtroDiagnosi.codiceCategoria" placeholder="Inserisci farmacia..." /> -->
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Diagnosi</label>
                            <input class="sa-page-search-component-input" v-model="filtroDiagnosi.diagnosi" placeholder="Inserisci diagnosi..." />
                        </b-col>
                    </b-row>
                </b-form>
            </sa-filter-component>
        </template>
        <template slot="table-body">
            <botox-configurazione-diagnosi-list-component ref="BotoxConfigurazioneDiagnosiListComponent" @afterLoadData="onAfterLoadData"></botox-configurazione-diagnosi-list-component>
            <botox-configurazione-diagnosi-edit-modal-component ref="BotoxConfigurazioneDiagnosiEditModalComponent"></botox-configurazione-diagnosi-edit-modal-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import SaFilterComponent from "../../../template/layout/components/SaFilterComponent.vue";
import BotoxConfigurazioneDiagnosiListComponent from "../components/BotoxConfigurazioneDiagnosiListComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import BotoxConfigurazioneDiagnosiEditModalComponent from "../components/BotoxConfigurazioneDiagnosiEditModalComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout, BotoxConfigurazioneDiagnosiListComponent, SaFilterComponent, BotoxConfigurazioneDiagnosiEditModalComponent },
    data() {
        return {
            filtroDiagnosi: {
                codiceCategoria: null,
                diagnosi: null,
                pege: 0,
                forPage: 0,
            },
            btnNewVisible: true,
            pathResource: "",
            linkedit: "/farmacie",
            categorieOptions: {},
            showModalLoading: false,
            pathResourceCategorieDiagnosi: "/botoxdiagnosicategorie",
            cont: 0,
        };
    },
    mounted() {
        let me = this;
        if (sessionStorage["filtroDiagnosi"]) {
            me.filtroDiagnosi = JSON.parse(sessionStorage["filtroDiagnosi"]);
        }
        me.loadCategorieDiagnosi();
        me.loadData();
    },
    methods: {
        loadCategorieDiagnosi() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceCategorieDiagnosi, {}, me.loadCategorieDiagnosiSuccess, me.loadCategorieDiagnosiError);
        },
        loadCategorieDiagnosiSuccess(response) {
            let me = this;
            me.categorieOptions = response.data.data.list;
            me.categorieOptions.unshift({ categoria: null, descrizione: "-Seleziona Valore-" });
            me.$emit("afterLoadData");
        },
        loadCategorieDiagnosiError(error) {
            let me = this;
            me.$emit("afterLoadData");
            console.log("Errore nel caricamento dei dati", error);
        },
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.BotoxConfigurazioneDiagnosiListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onSubmitFarmacie() {
            let me = this;
            sessionStorage["filtroDiagnosi"] = JSON.stringify(me.filtroDiagnosi);
            me.$refs.BotoxConfigurazioneDiagnosiListComponent.loadData();
        },
        resetfiltroDiagnosi() {
            let me = this;
            me.filtroDiagnosi = {
                codiceCategoria: null,
                diagnosi: null,
            };
            sessionStorage["filtroDiagnosi"] = JSON.stringify(me.filtroDiagnosi);
            this.loadData();
        },
        onClickNuovo() {
            let me = this;
            me.$refs.BotoxConfigurazioneDiagnosiEditModalComponent.init(null);
        },
    },
};
</script>

<style></style>
